import { FaXTwitter, FaGithub, FaLinkedin } from "react-icons/fa6";

const profilePic = process.env.PUBLIC_URL + 'PFPfilter.png';

export default function Home() {
  const socialLinks = [
    {
      component: <FaLinkedin size={24} />,
      link: 'https://www.linkedin.com/in/nicholas-galupi-b4228a2b4/'
    },
    {
      component: <FaGithub size={24} />,
      link: 'https://github.com/PureZinc'
    },
    {
      component: <FaXTwitter size={24} />,
      link: 'https://x.com/GalupiNich4092'
    },
  ]

  return (
    <header>
      <div className="header-content">        
        <p className="text-5xl font-bold">Nicholas Galupi</p>
        <p>"Together, we can build the future!"</p>
        <div className="social-links mx-4 my-3 flex items-center"> 
          {socialLinks.map((link, index) => (
            <a key={index} href={link.link} 
              className="text-white hover:text-blue-600 mx-4" 
              target="_blank" rel="noreferrer"
            >
              {link.component}
            </a>
          ))}
        </div>
      </div>
      <div className="mx-4 my-3">
        <img width="300" height="300" src={profilePic} alt="PFP" 
          className="object-cover rounded-md border-blue-950 border-4"
        />
      </div>
    </header>
  )
}
